<template>
    <InfoLayout1 class="bottom-pad-override">
        <template #header-img><div class="header-img"></div></template>
        <template #content-div>
            <div class="mixed-content">
                <p>Before we built anything, we asked ourselves the one question most people are too busy to ask: <br>Why the hell are we doing this?</p>
                <p>Not just another NFT drop. Not another “disruptive” web3 project. We wanted to create something with a soul, something that pushes culture forward and rewrites the rules while everyone else is busy refreshing the floor price.</p>
                <p>And the answer? It wasn’t a pitch deck. It was a manifesto.</p>

                <br>
                
                <p><b>We are the codebreakers, the visionaries of the digital age. In the shadows of the digital realm, we rise as the architects of tomorrow. Art is our weapon of change, technology is our compass.</b></p>
                <p><b>We do not follow trends; we set them. We don't just adapt; we innovate. We defy the ordinary and embrace the unknown. We collect the rare, the wild, the extraordinary. We are the degens, the early adopters, the relentless experimenters. We are the round pegs in square holes. We stand in line not for the product, but for the revolution it represents.</b></p>
                <p><b>We are the misfits, the dreamers, the ones crazy enough to believe we can change the world. We are Alpha Labs!</b></p>
            </div>

            <div>
                <img src="@/assets/imgs/logo-light.svg" class="logo center">
            </div>
        </template>
    </InfoLayout1>
</template>

<style lang="scss" scoped>
@use '@/assets/css/_tools' as *;
@use '@/assets/css/_base' as base;

div.header-img {
    @include responsive-bg-x4('@/assets/imgs/about/manifesto.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}

.bottom-pad-override {
    --bottom-pad: 0px;
}

.mixed-content p {
    line-height: 1.6;
    margin-bottom: .75em;
}

.logo {
    height: 100px;
    width: auto;
    margin-top: 64px;
    margin-bottom: 64px;
}
</style>